module.exports = __webpack_public_path__ + "static/media/essence.ee70eadb.jpg";